import React, {useState, useEffect, useRef} from 'react';
import {usePDF} from "@react-pdf/renderer";
import LuggageTagPdf from "./LuggageTagPdf";
import BoardingPassPdf from "./BoardingPassPdf";
import { Trans } from '@lingui/react/macro';
import * as Sentry from "@sentry/react";

const DownloadButton = (props) => {
    const [generateFile, setGenerateFile] = useState(false);

    if(generateFile) {
        return (
            <FileComponent {...props}/>
        )
    }

    return (
        <button className="block action-button action-button-enabled w-mobile" onClick={() => setGenerateFile(true)}>
            {props.label}
        </button>
    )
}

export default DownloadButton;

// a font or image fetch that failed, as worded by Chrome, Safari and Firefox
function isNetworkError(error) {
    return /Failed to fetch|Load failed|NetworkError/.test(error?.message || "");
}

const FileComponent = (props) => {
    let document = null;
    switch (props.type) {
        case "luggage":
            document = <LuggageTagPdf bookingData={props.bookingData} passengers={props.passengers}/>;
            break;
        case "boarding":
            document = <BoardingPassPdf bookingData={props.bookingData} passengers={props.passengers}/>;
            break;
    }

    const [instance, updateInstance] = usePDF({document});

    // network failures are left out, the reload below recovers them; anything else is a bug worth knowing about
    useEffect(() => {
        if(instance.error && !isNetworkError(instance.error)) {
            Sentry.captureException(instance.error, {
                level: "warning",
                fingerprint: ["pdf-generation-failed"],
                tags: {"pdf.type": props.type},
            });
        }
    }, [instance.error, props.type]);

    if(instance.error) {
        return (
            <div>
                <p>
                    <Trans id="unexpected_error_try_again">An unexpected error has happened please try again.</Trans>
                </p>
                {/* a reload, because react-pdf keeps a failed font load cached for the life of the page */}
                <button className="block action-button action-button-enabled w-mobile mt-4" onClick={() => window.location.reload()}>
                    <Trans id="try_again">Try again</Trans>
                </button>
            </div>
        )
    }

    if(instance.loading) {
        return (
            <div>
                <span><Trans id="generating_pdf">Generating PDF</Trans>...</span>
            </div>
        )
    }

    if(instance.url) {
        return (
            <AutoClickLink url={instance.url} label={props.label}/>
        )
    }

    return null;
}

const AutoClickLink = (props) => {
    const linkRef = useRef(null);

    useEffect(() => {
        linkRef.current.click();
    }, []);

    return (
        <a className="block action-button action-button-enabled w-mobile"
           ref={linkRef}
           href={props.url}
           target="_blank"
           rel="noopener noreferrer"
        >
            <Trans id="pdf_ready_click_to_download">Pdf ready - click to download</Trans>
        </a>
    )
}